<template>
  <modal-component
    :remove-outside-click="true"
    :is-displayed="isModalOpened"
    :title="$t('ResponseMessages.Messages')"
    @toggle-modal="$emit('toggle-modal')"
  >
    <loader v-if="isLoading" />
    <div class="px-6" v-else>
      <custom-table
        :is-data-source-loading="isDataSourceLoading"
        :is-action-list-not-displayed="true"
        :no-selection="true"
        :table-data="paginatedAssetResponseMessages.items"
        :table-headers="tableHeaders"
        :show-per-page="16"
        @force-refresh="getAllAssetResponseMessages()"
      />
    </div>
  </modal-component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ModalComponent from "@/core/Components/Modal.vue";
import CustomTable from "@/core/Components/CustomTable.vue";
import { ResponseMessagesObject } from "../Services/ResponseMessagesTypes";
import ResponseMessagesService from "@/modules/ResponseMessages/Services/ResponseMessagesService";
import { useToast } from "vue-toastification";
import { ErrorMessageFormatter } from "@/core/Services/GlobalFunctions";
import Loader from "@/core/Components/Loader.vue";

export default defineComponent({
  components: { CustomTable, ModalComponent, Loader },
  props: {
    isModalOpened: Boolean,
    assetId: {
      type: Number,
      required: true,
    },
  },
  emits: ["toggle-modal"],
  data() {
    return {
      responseMessagesService: new ResponseMessagesService(),
      isDataSourceLoading: false,
      isLoading: false,
      paginatedAssetResponseMessages: {} as ResponseMessagesObject,
      toast: useToast(),
      tableHeaders: {
        message: { header: (this as any).$t("ResponseMessages.Message"), visible: true },
        createdAt: {
          header: (this as any).$t("ResponseMessages.CreatedAt"),
          visible: true,
        },
        updatedAt: {
          header: (this as any).$t("ResponseMessages.UpdatedAt"),
          visible: true,
        },
        isActive: {
          header: (this as any).$t("ResponseMessages.IsActive"),
          visible: true,
        },
        isSent: {
          header: (this as any).$t("ResponseMessages.IsSent"),
          visible: true,
        },
      },
    };
  },

  async created() {
    this.isLoading = true;
    try {
      await this.getAllAssetResponseMessages();
    } catch (error) {
      this.toast.error(ErrorMessageFormatter(error));
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async getAllAssetResponseMessages() {
      this.isDataSourceLoading = true;
      try {
        this.paginatedAssetResponseMessages =
          await this.responseMessagesService.getAllAssetResponseMessages(
            1,
            10000,
            this.assetId
          );
      } catch (error) {
        this.toast.error(ErrorMessageFormatter(error));
      } finally {
        this.isDataSourceLoading = false;
      }
    },
  },
});
</script>

<style scoped></style>
